module.exports = __webpack_public_path__ + "media/images/athletes/3585-a45df4ee1cfb9c785fef63dc7f7c1c22.png";